import { Field, FieldProps, getIn } from "formik";

import { MembersPriceBlock, MembersPriceValueType } from "../base";
import { Path } from "./types";

type FormMembersPriceBlockProps<T> = {
  name: Path<T>;
  taxRate: number;
  customLabel?: string;
};

export const FormMembersPriceBlock = <T,>({
  name,
  taxRate,
  customLabel,
}: FormMembersPriceBlockProps<T>) => {
  return (
    <Field name={name}>
      {({
        field,
        form,
        meta: { touched },
      }: FieldProps<MembersPriceValueType>) => {
        const error = getIn(form.errors, name);

        return (
          <MembersPriceBlock
            value={field.value}
            onChange={(value) => {
              form.setFieldValue(name, value);
            }}
            taxRate={taxRate}
            exTaxError={touched && error?.exTaxPrice}
            incTaxError={touched && error?.incTaxPrice}
            customLabel={customLabel}
          />
        );
      }}
    </Field>
  );
};
